import React from 'react';
import { connect } from 'react-redux';
import { map, isNil } from 'lodash';

import { accountsByIdSelector } from 'selectors/accounts';
import { groupsByIdSelector } from 'selectors/groups';
import { exchangeRateChoicesSelector } from 'selectors/exchangeRateRows';
import { SAVE_EXCHANGE_RATE } from 'constants/actionTypes';

const ExchangeRateCellRenderer = ({
  choices,
  node,
  saveExchangeRate,
  accountsById,
  groupsById,
}) => {
  const isCGroup = !isNil(node.data.cgroupId);

  if (isCGroup) {
    return null;
  }

  const id = node.data.id;
  const isGroup = !!node.data.group;
  const item = isGroup ? groupsById[id] : accountsById[id];
  const exchangeRateIdValue = !!item?.exchangeRateId ? item.exchangeRateId : '';
  const value = exchangeRateIdValue;

  const defaultExchangeRateLabel = 'Default Exchange Rate';
  const mixedExchangeRateLabel = 'Mixed Exchange Rate';

  const isMixedExchangeRate = exchangeRateIdValue === 'MIXED_EXCHANGE_RATE';

  const choicesToDisplay = {
    ...(isMixedExchangeRate
      ? { [mixedExchangeRateLabel]: 'MIXED_EXCHANGE_RATE' }
      : {}),
    [defaultExchangeRateLabel]: '',
    ...choices,
  };

  const handleInputChange = (event) => {
    const { target } = event;
    const exchangeRateId = target.value;
    const itemType = !!node.data.group ? 'group' : 'account';

    saveExchangeRate(node.data.id, itemType, exchangeRateId);
  };

  return (
    <div className="exchangeRateCellRenderer">
      <select
        name="exchangeRateCellRendererDropdown"
        className="exchangeRateCellRendererDropdown"
        value={value}
        onChange={handleInputChange}
      >
        {map(choicesToDisplay, (value, key) => (
          <option key={key} value={value}>
            {key}
          </option>
        ))}
      </select>
    </div>
  );
};

const mapStateToProps = (state) => ({
  choices: exchangeRateChoicesSelector(state),
  accountsById: accountsByIdSelector(state),
  groupsById: groupsByIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  saveExchangeRate: (itemId, itemType, exchangeRateId) =>
    dispatch({ type: SAVE_EXCHANGE_RATE, itemId, itemType, exchangeRateId }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExchangeRateCellRenderer);
